<template>
  <Multiselect
    v-model="model"
    :options="options"
    label="value"
    :multiple="true"
    :close-on-select="false"
    :allow-empty="true"
    track-by="key"
    selected-label="✓"
    deselect-label="✓"
    select-label=""
    :placeholder="$t('label.payment_method')"
    @input="input"
  >
    <template slot="selection" slot-scope="{ values, isOpen }">
      <span v-if="values.length && !isOpen" class="multiselect__single">
        {{ label }}
      </span>
    </template>
  </Multiselect>
</template>

<script>
import Multiselect from "vue-multiselect";
import { pluck, isNil, join, filter } from "ramda";

export default {
  name: "SelectPaymentMethods",
  components: {
    Multiselect,
  },
  props: {
    value: {
      type: [Array, String],
      default: () => [],
    },
  },
  data: () => ({
    model: null,
  }),
  computed: {
    options() {
      return [
        {
          key: "cash_delivery",
          value: this.$t("label.cash"),
        },
        {
          key: "card_delivery",
          value: this.$t("label.card"),
        },
        {
          key: "card_online",
          value: this.$t("label.card_online"),
        },
      ];
    },
    label() {
      if (isNil(this.model)) return null;
      return join(", ", pluck("value", this.model));
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (isNil(val)) {
          this.model = null;
          return;
        }

        this.model = filter((obj) => val.includes(obj.key), this.options);
      },
    },
  },
  methods: {
    input(value) {
      this.$emit("input", pluck("key", value));
    },
  },
};
</script>
